import { useLocalStorage } from '@rehooks/local-storage';
import IdentityResponse from '../types/IdentityResponse';

/** @deprecated Do not use this hook. Use "useIdentity" instead. */
const useLocalStorageIdentity = (userIdentifier: string) => {
  return useLocalStorage<IdentityResponse>(`ZNavIdentity.${userIdentifier}`);
};

export default useLocalStorageIdentity;
